import React, { useEffect, useState } from 'react';
import { InformationChip } from '@europrocurement/flexy-components';
import { PaletteColor, Typography } from '@mui/material';
import { DossierArticle } from '../../hooks';
import { DossierArticleProcessMenuItemProps } from '../DossierArticleProcessMenu/DossierArticleProcessMenu';

export type DossierArticleProcessStatusProps = {
    statusLabel: string;
    statusColor: PaletteColor;
    getItemActions?: (article: DossierArticle) => Array<DossierArticleProcessMenuItemProps>;
    article?: DossierArticle;
};

const DossierArticleProcessStatus: React.FunctionComponent<DossierArticleProcessStatusProps> =
    function (props) {
        const { statusLabel, statusColor, getItemActions = () => [], article } = props;
        const [cliquable, setCliquable] = useState<boolean>(false);

        const [actionClick, setActionClick] = useState<(article?: DossierArticle) => void>(
            () => {},
        );

        // check if the "update status validator is available in the actions"
        useEffect(() => {
            if (article && getItemActions) {
                const itemsActions = getItemActions(article);
                if (itemsActions) {
                    const updateValidatorAction = itemsActions.find(
                        (action) => action.label === 'Modifier le statut valideur',
                    );

                    if (updateValidatorAction && article) {
                        setCliquable(true);
                        setActionClick(() => updateValidatorAction.onClick);
                    }
                }
            }
        }, [getItemActions, article]);

        const handleClick = () => {
            if (article && actionClick) {
                actionClick(article);
            }
        };

        return (
            <InformationChip
                color={statusColor.light}
                sx={{ cursor: cliquable ? 'pointer' : 'default' }}
                label={
                    <Typography
                        onClick={handleClick}
                        variant="l2dbodys"
                        color={statusColor.main}
                    >
                        {statusLabel}
                    </Typography>
                }
            />
        );
    };

export default DossierArticleProcessStatus;
